import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class ReportsMenuService {

  constructor(readonly httpClient: HttpClient) { }

  getReports(): Observable<any> {
    return this.httpClient.get<any>("/assets/all-reports/config/reports.json");
  }
}
